// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1db3a4bc","455":"86c44a15"}[chunkId] + ".chunk.js";
};